import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, disablePrevNextBtns } from '../helpers/carousel-buttons';

(() => {
  const caseStudySlider = document.querySelectorAll('.m06');

  const removeDotClasses = (dots, newDot) => {
    dots.forEach(dot => dot.classList.remove('is-selected'));
    newDot.classList.add('is-selected');
  };

  caseStudySlider.forEach(slider => {
    const contentSliderNode = slider.querySelector('.m06__wrapper--content');
    const mediaSliderNode = slider.querySelector('.m06__wrapper--media');

    if (mediaSliderNode === null || contentSliderNode === null) {
      return;
    }

    const options = {
      loop: true,
      draggable: window.outerWidth < 1040
    };

    const contentEmbla = EmblaCarousel(contentSliderNode, options);
    const mediaEmbla = EmblaCarousel(mediaSliderNode, options);

    const dots = slider.querySelectorAll('[data-dot]');
    const prevBtn = slider.querySelector('.m06__nav--prev');
    const nextBtn = slider.querySelector('.m06__nav--next');
    const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, contentEmbla);

    setupPrevNextBtns(prevBtn, nextBtn, contentEmbla);

    contentEmbla.on('init', disablePrevAndNextBtns);

    contentEmbla.on('select', () => {
      const currentSlide = parseInt(contentEmbla.selectedScrollSnap());
      disablePrevAndNextBtns();
      removeDotClasses(dots, dots[currentSlide]);
      mediaEmbla.scrollTo(currentSlide);
    });

    mediaEmbla.on('select', () => {
      const currentSlide = parseInt(contentEmbla.selectedScrollSnap());
      contentEmbla.scrollTo(mediaEmbla.selectedScrollSnap());
      removeDotClasses(dots, dots[parseInt(contentEmbla.selectedScrollSnap())]);
      contentEmbla.scrollTo(currentSlide);
    });

    contentEmbla.on('resize', () => {
      mediaEmbla.reInit({ draggable: window.outerWidth < 1040 });
      contentEmbla.reInit({ draggable: window.outerWidth < 1040 });
    });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        removeDotClasses(dots, dot);
        const dotIndex = parseInt(dot.getAttribute('data-dot'));
        contentEmbla.scrollTo(dotIndex);
        mediaEmbla.scrollTo(dotIndex);
      });
    });
  });
})();
